var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-navbar-match-popup" }, [
    _setup.loading
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [_c(_setup.VLoading)],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_setup.loading
      ? _c("div", { staticClass: "custom-navbar-match-panel" }, [
          _c(
            "div",
            { staticClass: "custom-navbar-match-left-panel" },
            _vm._l(_setup.bannerItems, function (card) {
              return _c(
                "a",
                {
                  key: card.jump_url,
                  staticClass: "banner-match-card",
                  attrs: { href: card.jump_url },
                },
                [_c("img", { attrs: { src: card.cover } })]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "custom-navbar-match-panel-separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "custom-navbar-match-right-panel" }, [
            _c(
              "div",
              { staticClass: "hot-match-list" },
              [
                _c("div", { staticClass: "hot-match-list-title" }, [
                  _vm._v("热门赛事"),
                ]),
                _vm._v(" "),
                _vm._l(_setup.hotItems, function (card) {
                  return _c(
                    "a",
                    {
                      key: card.jump_url,
                      staticClass: "hot-match-card",
                      attrs: { href: card.jump_url, title: card.name },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "hot-match-card-status",
                          class: {
                            "in-progress":
                              card.status ===
                              _setup.MatchHotItemStatus.InProgress,
                          },
                        },
                        [
                          card.status === _setup.MatchHotItemStatus.NotStarted
                            ? [_vm._v("未开始")]
                            : _vm._e(),
                          _vm._v(" "),
                          card.status === _setup.MatchHotItemStatus.InProgress
                            ? [_vm._v("进行中")]
                            : _vm._e(),
                          _vm._v(" "),
                          card.status === _setup.MatchHotItemStatus.Finished
                            ? [_vm._v("已结束")]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "hot-match-card-title" }, [
                        _vm._v(
                          "\n            " + _vm._s(card.name) + "\n          "
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "preview-match-list" },
              [
                _c("div", { staticClass: "preview-match-list-title" }, [
                  _vm._v("精彩预告"),
                ]),
                _vm._v(" "),
                _vm._l(_setup.previewItems, function (card) {
                  return _c(
                    "a",
                    {
                      key: card.jump_url,
                      staticClass: "preview-match-card",
                      attrs: { href: card.jump_url, title: card.name },
                    },
                    [
                      _c("div", { staticClass: "preview-match-date" }, [
                        _vm._v(_vm._s(card.stime)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "preview-match-title" }, [
                        _vm._v(_vm._s(card.name)),
                      ]),
                      _vm._v(" "),
                      _c(
                        _setup.VButton,
                        {
                          staticClass: "preview-match-subscribe",
                          attrs: {
                            type: card.fav_status === 0 ? "primary" : "light",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _setup.toggleSubscribe(card)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                card.fav_status === 0 ? "订阅" : "已订阅"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }